import {Validator} from './validator';

export class StripeValidator implements Validator {
    validate(): Promise<boolean> {
        const formElement = document.getElementById('df_stripe_form') as HTMLSelectElement;
        if (formElement) {
            return Promise.resolve(formElement.checkValidity());
        }

        return Promise.resolve(false);
    }
}
